module.exports = __webpack_public_path__ + "static/media/kuboou1.6576cc4a.png";